/**
 * Notification Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriptionModel { 
    type: SubscriptionModel.TypeEnum;
    duration: number;
}
export namespace SubscriptionModel {
    export type TypeEnum = 'CLIPPING' | 'ANALYTICS' | 'TRANSCRIPTIONS' | 'CONTRACT_NOTICES' | 'CONTRACT_NOTICES_KOSOVO' | 'CONTRACT_NOTICES_ALBANIA' | 'CONTRACT_NOTICES_ANNOUNCEMENTS' | 'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO' | 'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA' | 'SALES' | 'BANKRUPTCIES' | 'MACEDONIA_NOTICES_BUNDLE' | 'KOSOVO_NOTICES_BUNDLE' | 'MACEDONIA_KOSOVO_NOTICES_BUNDLE';
    export const TypeEnum = {
        CLIPPING: 'CLIPPING' as TypeEnum,
        ANALYTICS: 'ANALYTICS' as TypeEnum,
        TRANSCRIPTIONS: 'TRANSCRIPTIONS' as TypeEnum,
        CONTRACTNOTICES: 'CONTRACT_NOTICES' as TypeEnum,
        CONTRACTNOTICESKOSOVO: 'CONTRACT_NOTICES_KOSOVO' as TypeEnum,
        CONTRACTNOTICESALBANIA: 'CONTRACT_NOTICES_ALBANIA' as TypeEnum,
        CONTRACTNOTICESANNOUNCEMENTS: 'CONTRACT_NOTICES_ANNOUNCEMENTS' as TypeEnum,
        CONTRACTNOTICESANNOUNCEMENTSKOSOVO: 'CONTRACT_NOTICES_ANNOUNCEMENTS_KOSOVO' as TypeEnum,
        CONTRACTNOTICESANNOUNCEMENTSALBANIA: 'CONTRACT_NOTICES_ANNOUNCEMENTS_ALBANIA' as TypeEnum,
        SALES: 'SALES' as TypeEnum,
        BANKRUPTCIES: 'BANKRUPTCIES' as TypeEnum,
        MACEDONIANOTICESBUNDLE: 'MACEDONIA_NOTICES_BUNDLE' as TypeEnum,
        KOSOVONOTICESBUNDLE: 'KOSOVO_NOTICES_BUNDLE' as TypeEnum,
        MACEDONIAKOSOVONOTICESBUNDLE: 'MACEDONIA_KOSOVO_NOTICES_BUNDLE' as TypeEnum
    };
}